"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.useClassNames = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var useClassNames = function useClassNames(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$alias = _ref.alias,
      alias = _ref$alias === void 0 ? '' : _ref$alias,
      _ref$modifierChar = _ref.modifierChar,
      modifierChar = _ref$modifierChar === void 0 ? '___' : _ref$modifierChar,
      _ref$elementChar = _ref.elementChar,
      elementChar = _ref$elementChar === void 0 ? '_' : _ref$elementChar,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["className", "alias", "modifierChar", "elementChar"]);

  var parseModifier = function parseModifier(modifier) {
    if (!modifier || !(modifier instanceof Object)) {
      throw Error('Modifier is required and should be an Object');
    } else {
      return Object.keys(modifier).map(function (modifierId) {
        var modifierValue = modifier[modifierId];

        if (typeof modifierValue === 'boolean') {
          if (modifierValue) {
            return ("" + modifierChar + modifierId).trim();
          } else {
            return '';
          }
        } else if (typeof modifierValue === 'string' || typeof modifierValue === 'number') {
          return ("" + modifierChar + modifierValue).trim();
        } else {
          return '';
        }
      }).join('');
    }
  };

  var parseToEM = function parseToEM(E, M) {
    if (!M) {
      return '';
    } else if (M instanceof Array) {
      var MS = M.map(function (m) {
        return parseToEM(E, m);
      }).join(' ');

      if (MS) {
        return ("" + MS).trim();
      } else {
        return '';
      }
    } else {
      var _MS = parseModifier(M);

      if (_MS) {
        return ("" + E + _MS).trim();
      } else {
        return '';
      }
    }
  };

  var classNames = function classNames() {
    for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
      options[_key] = arguments[_key];
    }

    var B = alias;

    if (!options || !options.length) {
      return B;
    } else {
      if (typeof options[0] === 'string') {
        var E = options[0];
        var BE = ("" + B + elementChar + E).trim();
        var BEM = '';

        if (options[1]) {
          BEM = parseToEM(BE, options[1]);
        }

        return (BE + " " + BEM).trim();
      } else if (options[0] instanceof Array) {
        var M = options[0].map(function (modifiers) {
          return parseToEM(B, modifiers);
        }).join(" ").trim();
        return (B + " " + M).trim();
      } else if (options[0] instanceof Object) {
        var BM = parseToEM(B, options[0]);
        return (B + " " + BM).trim();
      }
    }
  };

  return (0, _extends2.default)({
    className: className,
    classNames: classNames
  }, restProps);
};
/**
 * className({ trigger: {
 * }})
 *
 */


exports.useClassNames = useClassNames;
var _default = useClassNames;
exports.default = _default;